export default __webpack_public_path__ + "images/memory-applications.svg";